import { SectionHead } from "./SectionHead";
import { BonusUGC } from "./BonusUGC";
import { BonusTeam } from "./BonusTeam";
import { ClickForecast } from "./ClickForecast";
import { GoogleMock } from "./GoogleMock";
import { SpilloverTotal } from "./SpilloverTotal";
import { FourBenefits } from "./FourBenefits";
import { SeoBlock } from "./SeoBlock";
import { OTA_PRICES, PROJECT_PRICES } from "../data/proposal";

const Block = ({ no, title, sub, children, id }) => (
  <div id={`benefit-${id}`} data-testid={`bonus-${id}`} className="scroll-mt-20 mt-16 border-t border-[var(--line)] pt-12">
    <h3 className="flex items-baseline gap-3 text-xl font-black text-[var(--ink)] md:text-2xl">
      <span className="text-[var(--teal-d)]">{no}</span>{title}
    </h3>
    {sub && <p className="mt-1 text-base font-bold text-[var(--teal-d)] md:text-lg">{sub}</p>}
    {children}
  </div>
);

const OtaLogos = () => (
  <div className="mt-6 flex flex-wrap gap-3">
    {["Agoda", "Booking.com", "Trip.com"].map((n) => (
      <span key={n} className="rounded-full border border-[var(--line)] bg-white px-4 py-2 text-sm font-black text-[var(--ink)]">{n}</span>
    ))}
  </div>
);

export const Bonus = () => (
  <section data-testid="bonus-section" className="mx-auto max-w-6xl px-5 py-16">
    <SectionHead no="03" title="外溢效益總覽" sub="不算在直接效應裡，曝光變大後另外多出來的效益" />
    <SpilloverTotal />
    <FourBenefits />
    <Block no="A" id="ugc" title="UGC ×3" sub="客人自發分享變多，曝光再多一倍"><BonusUGC /></Block>
    <Block no="B" id="team" title="團建成長" sub="詢問 2 倍以上，業績 +8%～25%"><BonusTeam /></Block>
    <Block no="C" id="ota" title="訂房網站加碼" sub="Agoda、Booking、Trip 的訂房也會增加">
      <p className="mt-3 text-[var(--text)]">名人堂知名度變高，客人也會去訂房網站搜尋。過去經驗：大量曝光期間，Agoda、Booking、Trip 會多出精準曝光量 <b className="text-[var(--teal-d)]">0.7%–1%</b> 的點擊。</p>
      <OtaLogos />
      <ClickForecast id="ota" prices={OTA_PRICES} />
    </Block>
    <Block no="D" id="google" title="Google 直達官網" sub="有人直接搜尋到名人堂官網的人客多專案">
      <p className="mt-3 text-[var(--text)]">看過影片的人，會自己上 Google 搜尋，點進名人堂官網上的人客多專案頁。點擊量同樣約是精準曝光量的 <b className="text-[var(--teal-d)]">0.7%–1%</b>。</p>
      <GoogleMock />
      <ClickForecast id="google" prices={PROJECT_PRICES} />
    </Block>
    <Block no="+" id="seo" title="SEO 排名往前" sub="附加效益，之後可以合作"><SeoBlock /></Block>
  </section>
);
